import Cookies from "../lib/js.cookie.js";

$(document).ready(function () {
	//------------------------------------------
	// Bouton modal
	//------------------------------------------
	const $modal = $(".js-modal");

	if ($modal) {
		const $modalButton = $(".js-modal-button", $modal);

		$modalButton.on("click", () => $modal.toggle());
	}

	//------------------------------------------
	// Bouton menu
	//------------------------------------------
	var jBtn = $(".btnMenu"),
		jMenu = $(".Menu"),
		jClose = $(".Menu-close");

	jBtn.click(function () {
		jMenu.addClass("isOpen");
		return false;
	});

	jClose.click(function () {
		jMenu.removeClass("isOpen");
		return false;
	});

	//------------------------------------------
	// Skip links
	//------------------------------------------
	var jSkip = $("#skip-link"),
		jLinks = $("a", jSkip);

	jLinks
		.blur(function () {
			jSkip.removeClass("focus");
		})
		.focus(function () {
			jSkip.addClass("focus");
		});

	//------------------------------------------
	// Dotdotdot / Cut des textes trop longs avec "..."
	//------------------------------------------

	$(".dotdotdot").dotdotdot({
		ellipsis: "...",
		wrap: "letter",
		fallbackToLetter: true,
		watch: true,
		tolerance: 0,
		callback: function (isTruncated, orgContent) {},
		lastCharacter: {
			remove: [" ", ",", ";", ".", "!", "?"],
			noEllipsis: [],
		},
	});

//   var today = new Date();
//   var currentYear = today.getFullYear();
//   var someDate = new Date(`${currentYear}/01/02`);
//   var limitDate = new Date(`${currentYear}/01/31`);
//   today = today.getTime();
//   someDate = someDate.getTime();
//   limitDate = limitDate.getTime();

//   var datesAreSame = ((someDate <= today) && (today <= limitDate));

//   let $popinVoeux = $('.Popin--voeux');

//   var cookieVoeux = Cookies.get('voeux');

//   if (!cookieVoeux) {
//       let $videoVoeux = $('.Popin-video', $popinVoeux),
//           $popinClose = $('.Popin-close', $popinVoeux),
//           $popinOverlay = $('.Popin-overlay', $popinVoeux);
//       // initialisation de la video.
//       $videoVoeux.videoframe({autoplay:true});

//       let tl = new TimelineLite({
//           onComplete: () => {
//               // lancement de l'autoplay & création du cookie.
//               $videoVoeux.videoframe('play');
//               Cookies.set("voeux", true, { expires: 30 });

//           }
//       });

//       tl.set($popinVoeux, { autoAlpha: 1, ease: Power4.easeOut })
//       tl.to($popinOverlay, 0.7, { autoAlpha: 1, ease: Power4.easeOut }, .5)
//       tl.fromTo($videoVoeux, 0.7, { y: '+=80', autoAlpha: 0 }, { y: 0, autoAlpha: 1, ease: Power4.easeOut })
//       tl.fromTo($popinClose, 0.7, { y: '-=50' }, { y: 0, autoAlpha: 1, ease: Power4.easeOut });


//       $popinClose.add($popinOverlay).click(function() {
//           const tl = new TimelineLite({
//               onComplete: () => {
//                   $popinVoeux.css('display', 'none')
//                   $videoVoeux.videoframe('stop');
//               }
//           });
//           tl.to($videoVoeux, 0.7, { y: '-=80', autoAlpha: 0, ease: Power4.easeOut });
//           tl.to($popinOverlay, 0.7, { autoAlpha: 0, ease: Power4.easeOut }, 0);

//       });
//   }

});
